// Real screenshots provided by the user
export const ASSETS = {
  desktop: {
    dashboardLight:
      "https://customer-assets.emergentagent.com/job_7847f1e1-8608-428f-a24c-706fe28875ac/artifacts/6t5eatey_image.png",
    dashboardDark:
      "https://customer-assets.emergentagent.com/job_7847f1e1-8608-428f-a24c-706fe28875ac/artifacts/cthgenao_image.png",
    mapaMesas:
      "https://customer-assets.emergentagent.com/job_7847f1e1-8608-428f-a24c-706fe28875ac/artifacts/oqgkbd0k_image.png",
    categorias:
      "https://customer-assets.emergentagent.com/job_7847f1e1-8608-428f-a24c-706fe28875ac/artifacts/50q5bt6t_image.png",
    procesarPago:
      "https://customer-assets.emergentagent.com/job_7847f1e1-8608-428f-a24c-706fe28875ac/artifacts/aq1ahm99_image.png",
  },
  mobile: {
    login:
      "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/npregcie_WhatsApp%20Image%202026-05-12%20at%208.25.11%20PM.jpeg",
    mapaMesas:
      "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/2842wi4e_WhatsApp%20Image%202026-05-12%20at%208.25.12%20PM%20%281%29.jpeg",
    categorias:
      "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/tr61img6_WhatsApp%20Image%202026-05-12%20at%208.25.12%20PM%20%282%29.jpeg",
    procesarPago:
      "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/5alod23i_WhatsApp%20Image%202026-05-12%20at%208.25.12%20PM%20%283%29.jpeg",
    dashboard:
      "https://customer-assets.emergentagent.com/job_vexly-landing/artifacts/ecyx2riv_WhatsApp%20Image%202026-05-12%20at%208.25.12%20PM.jpeg",
  },
};
